import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import cls from './Item.module.css';

export default class extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    labelClassName: PropTypes.string,
    valueClassName: PropTypes.string,
    label: PropTypes.string,
    renderer: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    boolean: PropTypes.bool,
    hidden: PropTypes.bool,
    itemProps: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    data: PropTypes.object,
  };

  static defaultProps = {
    className: '',
    labelClassName: '',
    valueClassName: '',
    boolean: false,
    hidden: false,
  };

  buildRenderer = () => {
    const { renderer } = this.props;

    if (typeof renderer === 'string') {
      return data => data[renderer];
    }

    if (typeof renderer !== 'function') {
      return () => null;
    }

    return renderer;
  };

  buildItemProps = () => {
    const { data, itemProps } = this.props;

    if (typeof itemProps === 'function') {
      return itemProps(data);
    }

    return itemProps;
  };

  render() {
    const { className, labelClassName, valueClassName, label, boolean, hidden, data } = this.props;

    if (hidden || !data) {
      return null;
    }

    const renderer = this.buildRenderer();
    const itemProps = this.buildItemProps();

    let value = renderer(data);
    if (boolean) {
      value = value ? 'yes' : 'no';
    }

    return (
      <div {...itemProps} className={cx(cls.item, className, itemProps?.className)}>
        <span className={cx(cls.label, labelClassName)}>{label}</span>
        <span className={cx(cls.value, valueClassName)}>{value}</span>
      </div>
    );
  }
}
